export enum CUSTOM_INPUT_PARAMETERS_NAMES {
  TARGET_VERSION = "targetVersion",
  FIRMWARE_UID = "firmwareUid",
  INCLUSION_PERIODS = "inclusionPeriods",
  DOWNLOAD_URL = "downloadUrl",
  VERSION = "version",
  TYPE = "type",
  SPECIFIC_CONFIG_UID = "specificConfigUid",
  GLOBAL_CONFIG_UID = "globalConfigUid",
}
